import { initializeApp } from "firebase/app";
import { getAuth }       from "firebase/auth";
import { getFirestore }  from "firebase/firestore";
import { getStorage }    from "firebase/storage";

const firebaseConfig = {
  apiKey:            "AIzaSyC1ivyjskk2ZIM9NN03PMW-CaIRGQuKplA",
  authDomain:        "lebmarket-bd69e.firebaseapp.com",
  projectId:         "lebmarket-bd69e",
  storageBucket:     "lebmarket-bd69e.firebasestorage.app",
  messagingSenderId: "329901083815",
  appId:             "1:329901083815:web:0d0186b558aaac089a9f82"
};

const app        = initializeApp(firebaseConfig);
export const auth    = getAuth(app);
export const db      = getFirestore(app);
export const storage = getStorage(app);
